export enum NXEnvironmentType {

    Demo = 1,
    Live = 2
}
